import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { IError } from '@shared/interfaces';
import { getError } from '@shared/utils/helpers';
import { IQueryParams } from './interfaces';

export const requestGetNewDealSheet = async (contactId: string) => {
  try {
    const url = `${SERVICES.CONTACT}/assignUser/dialer/${contactId}`;
    const response = await axios.post(url);

    return response?.data;
  } catch (err) {
    const error = err as IError;

    if (error.response.status !== 403) {
      Notistack.generalError(getError(err));
      return;
    }

    return err;
  }
};

export const requestFromLiveVox = async (params: IQueryParams) => {
  try {
    const url = `${SERVICES.CONTACT}/assignUser/dialer/livevox?${[
      params?.id && `contactId=${params.id}`,
      params?.phoneNumber && `phoneNumber=${params.phoneNumber}`
    ].filter(Boolean).join('&')}`;    
    const response = await axios.post(url);

    return response?.data;
  } catch (err) {
    const error = err as IError;

    if (error.response.status !== 403) {
      Notistack.generalError(getError(err));
      return;
    }

    return err;
  }
};